module.exports = __webpack_public_path__ + "static/media/outro-img.8261ee12.png";